"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _auth = require("@/utils/auth");

var _systemSetting = require("@/api/systemSetting");

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = {
  name: "index",
  data: function data() {
    return {
      pictureType: 'excel',
      myHeaders: {
        "X-Token": (0, _auth.getToken)()
      }
    };
  },
  methods: {
    // 上传
    handleUploadForm: function handleUploadForm(param) {
      var _this = this;

      var formData = new FormData(); // const data = {
      //   model: this.modelName ? this.modelName : this.$route.path.split("/")[1],
      //   pid: this.tableData.pid,
      // };

      formData.append("multipart", param.file);
      var loading = this.$loading({
        lock: true,
        text: "上传中，请稍候...",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)"
      });
      (0, _systemSetting.merchantImportApi)(formData).then(function (res) {
        loading.close();

        _this.$message.success("上传成功");

        _this.tableData.page = 1;

        _this.getFileList();
      }).catch(function (res) {
        loading.close();
      });
    },
    imgSaveToUrl: function imgSaveToUrl(event) {
      // 也可以用file
      this.localFile = event.raw; // 或者 this.localFile=file.raw
      // 转换操作可以不放到这个函数里面，
      // 因为这个函数会被多次触发，上传时触发，上传成功也触发

      var reader = new FileReader();
      reader.readAsDataURL(this.localFile); // 这里也可以直接写参数event.raw
      // 转换成功后的操作，reader.result即为转换后的DataURL ，
      // 它不需要自己定义，你可以console.integralLog(reader.result)看一下

      reader.onload = function () {// console.integralLog(reader.result)
      };
      /* 另外一种本地预览方法 */


      var URL = window.URL || window.webkitURL;
      this.localImg = URL.createObjectURL(event.raw); // 转换后的地址为 blob:http://xxx/7bf54338-74bb-47b9-9a7f-7a7093c716b5
    }
  }
};
exports.default = _default;